import { store } from "@/store/index";

// Reads at CALL time, never a snapshot: RTK Query's queryFn needs the token
// current at request time, and it refreshes during a session — a value
// captured at mount would go stale. Extracted packages receive this getter
// via their configure() entry point instead of importing the host store.
// authInfo is a JS reducer (securityToken: null until auth completes).
export const getSecurityToken = (): string | null =>
  (store.getState() as { authInfo?: { securityToken?: string | null } }).authInfo?.securityToken ??
  null;
